module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/join-our-agents/commissioni-agente.263e44193dd46a93b6b010a0259b1677.jpg";